import { lazy } from "react";

const routes = [
  {
    path: "/settings/seller-entities",
    element: lazy(() => import("../../pages/Settings/Organisation")),
  },
];

export default routes;
